import React from "react";
import {
  MailOutlined,
  TeamOutlined,
  WarningOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";

export const sampleCsvHref =
  "data:text/csv;charset=utf-8,first_name,last_name,phone,email%0AJohn,Smith,%2B911234567890,john%40example.com";

export const columnOptions = [
  { value: "ignore", label: "Ignore" },
  { value: "name", label: "Name / Full Name" },
  { value: "company", label: "Company" },
  { value: "phone", label: "Phone" },
  { value: "email", label: "Email" },
];

export const previewRows = [
  {
    id: 1,
    srNo: "1",
    firstName: "Antonio",
    lastName: "Cameron",
    company: "Macfarland-Moore",
    phone: "821-8545-2981",
  },
  {
    id: 2,
    srNo: "2",
    firstName: "Beatrice",
    lastName: "Nguyen",
    company: "Thompson",
    phone: "745-6234-9832",
  },
  {
    id: 3,
    srNo: "3",
    firstName: "Carlos",
    lastName: "Santos",
    company: "Delgado",
    phone: "912-3847-5764",
  },
  {
    id: 4,
    srNo: "4",
    firstName: "Diana",
    lastName: "Kumar",
    company: "Patel",
    phone: "634-7895-2146",
  },
  {
    id: 5,
    srNo: "5",
    firstName: "Elias",
    lastName: "Martinez",
    company: "Lopez",
    phone: "588-1423-8763",
  },
];

export const initialManualRows = [
  { id: 1, name: "", phone: "", email: "" },
  { id: 2, name: "", phone: "", email: "" },
  { id: 3, name: "", phone: "", email: "" },
  { id: 4, name: "", phone: "", email: "" },
];

export const audienceDetailRows = [
  {
    id: 1,
    name: "Tyrion Lannister",
    phone: "+91-9585658982",
    email: "tyrion@lannisters.com",
    channels: ["whatsapp", "email"],
  },
  {
    id: 2,
    name: "Robb Stark",
    phone: "+91-8595874568",
    email: "robb@starks.com",
    channels: ["whatsapp", "email"],
  },
  {
    id: 3,
    name: "Samwell Tarley",
    phone: "+91-8595874568",
    email: "samwell@tarleysl.com",
    channels: ["whatsapp", "email"],
  },
  {
    id: 4,
    name: "Arya Stark",
    phone: "+44-2039485762",
    email: "arya@winterfell.com",
    channels: ["whatsapp", "email"],
  },
  {
    id: 5,
    name: "Jon Snow",
    phone: "+1-4159823476",
    email: "jon@nightswatch.org",
    channels: ["whatsapp", "email"],
  },
  {
    id: 6,
    name: "Tyrion Lannister",
    phone: "+33-1456987321",
    email: "tyrion@casterlyrock.com",
    channels: ["whatsapp"],
  },
  {
    id: 7,
    name: "Cersei Lannister",
    phone: "+44-2076543210",
    email: "cersei@redkeep.gov",
    channels: ["whatsapp", "email"],
  },
  {
    id: 8,
    name: "Daenerys Targaryen",
    phone: "+971-5551234567",
    email: "dany@dragonstone.com",
    channels: ["email"],
  },
  {
    id: 9,
    name: "Bran Stark",
    phone: "+1-2125550198",
    email: "bran@threeeyedraven.net",
    channels: ["whatsapp", "email"],
  },
  {
    id: 10,
    name: "Sandor Clegane",
    phone: "+44-7734567890",
    email: "hound@kingslanding.com",
    channels: ["email"],
  },
  {
    id: 11,
    name: "Jorah Mormont",
    phone: "+1-6175558103",
    email: "jorah@bearisland.com",
    channels: ["whatsapp", "email"],
  },
];

export const validationCards = [
  {
    label: "Total Contacts",
    value: "2895",
    progressWidth: "tw-w-[72%]",
    iconWrapClass: "tw-bg-secondary-color tw-text-theme",
    progressClass: "tw-bg-theme",
    icon: <TeamOutlined />,
  },
  {
    label: "Whatsapp ready",
    value: "852",
    progressWidth: "tw-w-[66%]",
    iconWrapClass: "tw-bg-[#EAFBF0] tw-text-[#22C55E]",
    progressClass: "tw-bg-[#22C55E]",
    icon: <WhatsAppOutlined />,
  },
  {
    label: "Email ready",
    value: "1000",
    progressWidth: "tw-w-[68%]",
    iconWrapClass: "tw-bg-secondary-color tw-text-theme",
    progressClass: "tw-bg-theme",
    icon: <MailOutlined />,
  },
  {
    label: "Invalid",
    value: "0",
    progressWidth: "tw-w-[18%]",
    iconWrapClass: "tw-bg-[#FFF1ED] tw-text-[#FF7A59]",
    progressClass: "tw-bg-[#D9D3FF]",
    icon: <WarningOutlined />,
  },
];

export const statChips = [
  {
    label: "Email",
    value: "1,000",
    dotClass: "tw-bg-theme",
    textClass: "tw-text-theme",
    icon: <MailOutlined className="tw-text-[10px]" />,
  },
  {
    label: "WhatsApp",
    value: "895",
    dotClass: "tw-bg-[#22C55E]",
    textClass: "tw-text-[#16A34A]",
    icon: <WhatsAppOutlined className="tw-text-[10px]" />,
  },
  {
    label: "Invalid Removed",
    value: "0",
    dotClass: "tw-bg-border-primary",
    textClass: "tw-text-sub-text",
  },
  {
    label: "Duplicate Removed",
    value: "0",
    dotClass: "tw-bg-border-secondary",
    textClass: "tw-text-theme",
  },
];

export const formatFileSize = (size) => {
  if (!size) return "0 KB";
  const sizeInKb = size / 1024;
  if (sizeInKb < 1024) return `${Math.max(1, Math.round(sizeInKb))} KB`;
  return `${(sizeInKb / 1024).toFixed(1)} MB`;
};

export const makeDetectedRowsText = (file) => {
  if (!file) return "245 rows detected";
  return `${previewRows.length * 49} rows detected`;
};
